import { render, staticRenderFns } from "./qixiActivity.vue?vue&type=template&id=ec317644&"
import script from "./qixiActivity.vue?vue&type=script&lang=js&"
export * from "./qixiActivity.vue?vue&type=script&lang=js&"
import style0 from "./qixiActivity.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports